import React, { useState, useEffect } from "react";
import { Routes } from "./routes";
import { v4 as uuidv4 } from "uuid";
import TimeOutPopup from "./components/common/popUps/TimeOutPopup";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { RoutesObj } from "./routes";
import { onMessageListener } from "./FCMService";
import { accountActions } from "./store/accounts/accountActions";
import { useDispatch } from "react-redux";

// Import MSAL v2.x
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./config/msalConfig";
import { dashboardActions } from "./store/dashboard/dashboardActions";

// Create MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    // Initialize MSAL instance without handling redirect promise for popup flow
    msalInstance
      .initialize()
      .then(() => {
        console.log("MSAL initialized successfully");

        // Only handle redirect if we're not in a popup
        if (!window.opener) {
          return msalInstance
            .handleRedirectPromise()
            .then(response => {
              if (response) {
                console.log("MSAL redirect response:", response);
                // Process redirect response if needed
                if (response.account) {
                  localStorage.setItem(
                    "backend_api_token",
                    response.accessToken,
                  );
                  dispatch(dashboardActions.onChange("isOutlookLogin", true));
                }
              }
            })
            .catch(error => {
              console.error("MSAL redirect error:", error);
            });
        }
      })
      .catch(error => {
        console.error("MSAL initialization error:", error);
      });
  }, [dispatch]);

  // // Initialize MSAL
  // useEffect(() => {
  //   msalInstance
  //     .handleRedirectPromise()
  //     .then(response => {
  //       if (response) {
  //         console.log("MSAL redirect response:", response);
  //       }
  //     })
  //     .catch(error => {
  //       console.error("MSAL redirect error:", error);
  //     });
  // }, []);

  // Your existing useEffect hooks remain exactly the same...
  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;

    const messageHandler = event => {
      if (event.data.type === "FCM_MESSAGE") {
        console.log("Received FCM message:", event.data);
        const userId = localStorage.getItem("id");
        if (userId) {
          dispatch(accountActions.onGetNotification(userId));
        }
      }
    };

    navigator.serviceWorker.addEventListener("message", messageHandler);

    const requestPendingMessages = () => {
      if (navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({
          type: "REQUEST_PENDING_MESSAGES",
        });
      }
    };

    const intervalId = setInterval(requestPendingMessages, 30000);
    requestPendingMessages();

    const focusHandler = () => requestPendingMessages();
    window.addEventListener("focus", focusHandler);

    navigator.serviceWorker.ready.then(() => {
      requestPendingMessages();
    });

    return () => {
      clearInterval(intervalId);
      window.removeEventListener("focus", focusHandler);
      navigator.serviceWorker.removeEventListener("message", messageHandler);
    };
  }, [dispatch]);

  useEffect(() => {
    const guid = uuidv4();
    localStorage.setItem("guid", guid);
  }, []);
  useEffect(() => {
    const outlookToken = localStorage.getItem("backend_api_token");
    dispatch(
      dashboardActions.onChange("isOutlookLogin", outlookToken ? true : false),
    );
  }, []);

  const [tabHasFocus, setTabHasFocus] = useState(true);
  const [isTabDisActive, setIsTabDisActive] = useState(false);
  const [isLogout, setIsLogout] = useState(false);

  useEffect(() => {
    let timeInt;
    const handleFocus = () => {
      setTabHasFocus(true);
      clearInterval(timeInt);
    };

    const handleBlur = () => {
      if (
        window.location.pathname !== "/" &&
        window.location.pathname !== "/login"
      ) {
        setTabHasFocus(false);
        let total = 0;
        timeInt = setInterval(function () {
          total = total + 60000;
          if (total >= 1800000 && !isTabDisActive) {
            setIsTabDisActive(true);
          }
          if (total === 2700000) {
            setIsTabDisActive(false);
            clearInterval(timeInt);
            localStorage.removeItem("access_token");
            localStorage.removeItem("isAuthenticated");
            localStorage.removeItem("userEmail");
            localStorage.removeItem("isAdmin");
            localStorage.removeItem("name");
            localStorage.removeItem("lName");
            localStorage.removeItem("id");
            localStorage.removeItem("isShowProspect");

            setIsLogout("true");
          }
        }, 60000);
      }
    };

    window.addEventListener("focus", handleFocus);
    window.addEventListener("blur", handleBlur);

    return () => {
      window.removeEventListener("focus", handleFocus);
      window.removeEventListener("blur", handleBlur);
    };
  }, []);

  useEffect(() => {
    onMessageListener()
      .then(payload => {
        console.log("Foreground message received: ", payload);
        setTimeout(() => {
          const userId = localStorage.getItem("id");
          if (userId) {
            dispatch(accountActions.onGetNotification(userId));
          }
        }, 2000);
      })
      .catch(err => console.log("Failed to receive message: ", err));
  }, []);

  const handleClose = () => {
    setIsTabDisActive(false);
    clearInterval();
  };

  return (
    // Wrap your app with MsalProvider
    <MsalProvider instance={msalInstance}>
      <div className='App'>
        {isTabDisActive && (
          <TimeOutPopup
            openPopup={() => isTabDisActive}
            closePopup={handleClose}
          />
        )}
        {isLogout && (
          <Router>
            <Switch>
              <Route
                exact
                path={RoutesObj.Login.path}
                render={() => this.authAdminComponent()}
              />
            </Switch>
          </Router>
        )}
        <Routes />
      </div>
    </MsalProvider>
  );
}

export default App;
